import { xcss } from '@atlaskit/primitives';
import Pressable from '@atlaskit/primitives/pressable';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const buttonStyles = xcss({
  width: '100%',
  color: 'color.text.subtle',
  fontSize: '0.875rem',
  fontWeight: 400,
  paddingBlock: 'space.150',
  paddingInline: 'space.200',
  textAlign: 'left',
  backgroundColor: 'elevation.surface',
  /**
   * Using `border` directly instead of separate properties for width, style, and color so we
   * can set the border color to transparent when not focused.
   * Otherwise, the element will shift when the border is added.
   */
  border: "var(--ds-border-width-outline, 2px)".concat(" solid transparent"),
  ':focus-visible': {
    outline: 'none',
    borderWidth: 'border.width.outline',
    borderStyle: 'solid',
    borderColor: 'color.border.focused'
  },
  ':disabled': {
    color: 'color.text.disabled'
  }
});
const buttonEnabledStyles = xcss({
  ':hover': {
    backgroundColor: 'elevation.surface.hovered'
  },
  ':active': {
    backgroundColor: 'elevation.surface.pressed'
  }
});
export const ClearSelectionButton = _ref => {
  let {
    isDisabled,
    onClick
  } = _ref;
  return (
    /*#__PURE__*/
    _jsx(Pressable, {
      onClick: onClick,
      onKeyDown: onClick,
      isDisabled: isDisabled,
      xcss: [buttonStyles, !isDisabled && buttonEnabledStyles],
      children: "Clear selection"
    })
  );
};